import { render, staticRenderFns } from "./CodeList.vue?vue&type=template&id=01be144c&scoped=true"
import script from "./CodeList.vue?vue&type=script&lang=js"
export * from "./CodeList.vue?vue&type=script&lang=js"
import style0 from "./CodeList.vue?vue&type=style&index=0&id=01be144c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01be144c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01be144c')) {
      api.createRecord('01be144c', component.options)
    } else {
      api.reload('01be144c', component.options)
    }
    module.hot.accept("./CodeList.vue?vue&type=template&id=01be144c&scoped=true", function () {
      api.rerender('01be144c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/System/SystemBaseBarCode/CodeList/CodeList.vue"
export default component.exports